module.exports = __webpack_public_path__ + "static/img/h-03.ba579c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/h-03.jpg
// module id = Hz1u
// module chunks = 1